import { createSelector } from "reselect";

const getVariantQueryMode = (state) => state.variantQueryMode;

const getIfSomatic = createSelector(
  getVariantQueryMode,
  (queryModal) => queryModal.annotation_mode === "somatic"
);

export { getIfSomatic };
